module.exports = __webpack_public_path__ + "app/assets/images/man13-651a24aeb78df0b41782fb829f3abd30.jpg";